import React from 'react';
import { connect } from 'react-redux';
import BSAccordion from 'react-bootstrap/Accordion';

import CMSContent from '../CMSContent/index.jsx';

import { getIsOpenPortfolioCustom, setIsOpenPortfolioCustom} from '../../Store/portfolio.js';

/**
 * A wrapper around the react bootstrap Accordion, which sets the aria-expanded
 * attribute. This is done by "raw" bootstrap, but not by this plugin, and we
 * need it for our styling.
 */
class Accordion extends React.Component {
  constructor(props) {
    super(props);
  }
  
  setOpenState(isOpen) {
    this.props.setIsOpenPortfolioCustom(isOpen);
  }
  render() {
    return (
      <BSAccordion className="cs-accordion" activeKey={this.props.isOpen ? 'cs-accordion': undefined}>
         <BSAccordion.Toggle eventKey="cs-accordion" className="cs-accordion__toggle" onClick={() => this.setOpenState(!this.props.isOpen)} aria-expanded={this.props.isOpen?.toString()}>
          {this.props.title}
        </BSAccordion.Toggle>
        <BSAccordion.Collapse eventKey="cs-accordion">
          <div className="cs-accordion__content">
            <CMSContent>
              {this.props.children}
            </CMSContent>
          </div>
        </BSAccordion.Collapse>
      </BSAccordion>
    );
  }
}

const mapStateToProps = function(state) {
  const isOpen = getIsOpenPortfolioCustom(state);
  return {  
    isOpen,
  };
};

const mapDispatchToProps = function(dispatch) {
  return {
    setIsOpenPortfolioCustom: function(value) {
      dispatch(setIsOpenPortfolioCustom(value));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Accordion);

